import Phaser from "phaser";
import { BigNumber } from "@yjsgames/bignumber";
import { PALETTE_NUM } from "../themes/palette.js";

const HEALTH_BAR_W_RATIO = 0.68;
const HEALTH_BAR_H = 3;
const HEALTH_BAR_TOP_GAP = 2;

export function shouldShowBrickHpLabel(showHpLabel: boolean, isFullHp: boolean, hasActiveShield: boolean): boolean {
  if (hasActiveShield) return showHpLabel;
  return showHpLabel && !isFullHp;
}

export function drawBrickHealthBar(params: {
  readonly healthBar: Phaser.GameObjects.Graphics;
  readonly hp: BigNumber;
  readonly maxHp: BigNumber;
  readonly x: number;
  readonly y: number;
  readonly displayWidth: number;
  readonly displayHeight: number;
}): void {
  const ratio = params.maxHp.isZero() ? 0 : Phaser.Math.Clamp(params.hp.div(params.maxHp).toNumber(), 0, 1);
  const width = Math.max(12, params.displayWidth * HEALTH_BAR_W_RATIO);
  const left = params.x - width / 2;
  const top = params.y - params.displayHeight / 2 - HEALTH_BAR_H - HEALTH_BAR_TOP_GAP;
  const fill = ratio > 0.55 ? PALETTE_NUM.infoBlue : ratio > 0.25 ? PALETTE_NUM.accentAmber : PALETTE_NUM.signalDanger;
  params.healthBar
    .clear()
    .fillStyle(PALETTE_NUM.cellBg, 0.88)
    .fillRoundedRect(left, top, width, HEALTH_BAR_H, 1)
    .fillStyle(fill, 0.95)
    .fillRoundedRect(left, top, Math.max(1, width * ratio), HEALTH_BAR_H, 1)
    .setActive(true)
    .setVisible(true);
}
